import { render } from "./DemonstrateMuluDialog.vue?vue&type=template&id=60e4c31d"
import script from "./DemonstrateMuluDialog.vue?vue&type=script&lang=js"
export * from "./DemonstrateMuluDialog.vue?vue&type=script&lang=js"

import "./DemonstrateMuluDialog.vue?vue&type=style&index=0&id=60e4c31d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__